module.exports = __webpack_public_path__ + "assets/img/ms_icon.c6fbfc4e.png";